export enum ShipmentType {
    EXPRESS = 'EXPRESS',
    ADVANCED = 'ADVANCED',
    ENTERPRISE = 'ENTERPRISE'
}
